import React from 'react';
import { DatePicker } from '../../../../formikBindings';
import { IAnswerProps } from './types';

export const DateTimeAnswer: React.FC<IAnswerProps> = ({ name, enablestatus }) => (
    <DatePicker name={name} enabled={enablestatus} />
);
